import { useState, useEffect } from 'react';
import { useSnapshot } from 'valtio';
import { miscUiState } from '../globalState';
import './BossBarOverlay.css';
import BossBar from './BossBarOverlay';
export default () => {
    const { currentTouch } = useSnapshot(miscUiState);
    const [bossBars, setBossBars] = useState(new Map());
    const addBossBar = (bossBar) => {
        setBossBars(prevBossBars => new Map(prevBossBars.set(bossBar.entityUUID, {
            ...bossBar,
            lastUpdated: Date.now()
        })));
    };
    const removeBossBar = (bossBar) => {
        setBossBars(prevBossBars => {
            const newBossBars = new Map(prevBossBars);
            newBossBars.delete(bossBar.entityUUID);
            return newBossBars;
        });
    };
    useEffect(() => {
        bot.on('bossBarCreated', (bossBar) => {
            addBossBar(bossBar);
        });
        bot.on('bossBarUpdated', (bossBar) => {
            if (!bossBar)
                return;
            addBossBar(bossBar);
        });
        bot.on('bossBarDeleted', (bossBar) => {
            if (!bossBar)
                return;
            removeBossBar(bossBar);
        });
    }, []);
    return (<div className={`bossBars ${currentTouch ? 'mobile' : ''}`} id="bossBars">
      {[...bossBars.values()].map(bar => (<BossBar key={`${bar.entityUUID}-${bar.lastUpdated}`} bar={bar}/>))}
    </div>);
};
